import * as THREE from "three";
import Heatpoint from '../heatpointscontrol/heatpoint'
import gsap from "gsap";

export default class Hospital extends THREE.Object3D {
	constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer, visitedPinColor) {
		super();

        this.setupPin(pinColor, pinColorDark, visitedPinColor, camera, interactionManager, onPinClick, gltfanimations, mixer);
	}

    setupPin(pinColor, pinColorDark, visitedPinColor, camera, interactionManager, onPinClick, gltfanimations, mixer) {
        this.pinModel5 = new Heatpoint(null, "model/heatpointspa.glb");
        setTimeout(() => {
            this.pinModel5.setColor(pinColor);
        }, 1000);
        this.pinModel5.position.set(1.92, 0.40, 0.11);
        this.visited = false;
        interactionManager.add(this.pinModel5);

        this.pinModel5.addEventListener("click", () => this.onPinClick(pinColor, pinColorDark, visitedPinColor, camera, onPinClick, gltfanimations, mixer));
        this.pinModel5.addEventListener('mouseover', () => this.onMouseOver(pinColorDark));
        this.pinModel5.addEventListener('mouseout', () => this.onMouseOut(pinColor, visitedPinColor));

        this.add(this.pinModel5);
        this.rotationAngle = 0;
        this.rotatePin();
    }

    onPinClick(pinColor, pinColorDark, visitedPinColor, camera, onPinClick, gltfanimations, mixer) {
        onPinClick();
        gsap.to(camera.position, { x: 3.1, y: 1.1, z: 0.7, duration: 2.5, ease: "Power3.inOut" });
        this.triggerAnimations(gltfanimations, mixer, true);
        this.visited = true;
        this.pinModel5.setColor(visitedPinColor);
    }

    onMouseOver(pinColorDark) {
        document.body.style.cursor = 'pointer';
        this.pinModel5.setColor(pinColorDark);
    }

    onMouseOut(pinColor, visitedPinColor) {
        document.body.style.cursor = 'default';
        this.pinModel5.setColor(this.visited ? visitedPinColor : pinColor);
    }

    triggerAnimations(gltfanimations, mixer, modal) {
        this.stadt = THREE.AnimationClip.findByName(gltfanimations, 'Die ganze Stadt.005Action');
        this.park1 = THREE.AnimationClip.findByName(gltfanimations, 'Empty.003Action');
        this.wellness = THREE.AnimationClip.findByName(gltfanimations, 'Wellness CampAction');
        this.stadt1 = mixer.clipAction(this.stadt);
        this.park = mixer.clipAction(this.park1);
        this.wellness1 = mixer.clipAction(this.wellness);
        const modal3 = document.getElementById('modal3');
        setTimeout(() => {
        if (this.stadt1.isRunning()) {
            this.park.stop();
            this.stadt1.stop();
            this.wellness1.stop();
            this.park.reset();
            this.wellness1.reset();
            this.stadt1.reset();
            this.park.timeScale = 1;
            this.stadt1.timeScale = 1;
            this.wellness1.timeScale = 1;
            setTimeout(() => {
            this.park.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            this.stadt1.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            this.wellness1.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            }, 1500);
            setTimeout(() => {
                this.wellness1.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            }, 3500);
        } else {
            this.park.reset();
            this.stadt1.reset();
            this.wellness1.reset();
            this.park.timeScale = 1;
            this.stadt1.timeScale = 1;
            this.wellness1.timeScale = 1;
            this.park.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            this.stadt1.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            setTimeout(() => {
                this.wellness1.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            }, 2000);
        }
            if(modal){
                setTimeout(() => {
                    modal3.classList.remove('hidden');
                }, 3000);
            }
        }, 2500);

        const self = this;
        modal3.addEventListener('click', function() {
            modal3.classList.add('hidden');
            self.stadt1.timeScale = -1;
            self.park.timeScale = -1;
            self.wellness1.timeScale = -1;
            self.stadt1.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            self.park.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            self.wellness1.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            self.stadt1.reset();
            self.wellness1.reset();
            self.park.reset();
        });
    }

    resetAnimations(gltfanimations, mixer) {
        const stadt = THREE.AnimationClip.findByName(gltfanimations, 'Die ganze Stadt.005Action');
        const wellness = THREE.AnimationClip.findByName(gltfanimations, 'Wellness CampAction');
        const park1 = THREE.AnimationClip.findByName(gltfanimations, 'Empty.003Action');
        const stadt1 = mixer.clipAction(stadt);
        const park = mixer.clipAction(park1);
        const wellness1 = mixer.clipAction(wellness);
        stadt1.stop();
        wellness1.stop();
        park.stop();
        stadt1.reset();
        wellness1.reset();
        park.reset();
        stadt1.timeScale = 1;
        wellness1.timeScale = 1;   
    }

	rotatePin() {
        this.rotationData = { angle: 0 };
        gsap.to(this.rotationData, {
            angle: "+=" + 2 * Math.PI, 
            duration: 10,
            ease: "none", 
            onUpdate: () => {
                this.pinModel5.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle);
            },
            repeat: -1
        });
	}
}